<template>
    <div class="left-sidenav">
        <ul class="metismenu left-sidenav-menu menu-sidebar-layout" v-if="$cookies.get('type_user_login') == 'instance'">
            <li :class="{ 'show': $store.state.permission.includes('dashboard.index'),  }">
                <router-link :to="{ name: 'instanceDashboard' }" 
                    :class="setActive(['instanceDashboard'])">
                    <i class="ti-bar-chart"></i>
                    <span>Beranda</span>
                </router-link>
            </li>

            <!-- <li class="show" v-if="$store.state.userData.role_id == 1">
                <router-link :to="{ name: 'instanceFormEngine' }"
                    :class="setActive(['instanceFormEngine', 'instanceFormEngineCreate', 'instanceFormEngineEdit'])">
                    <i class="ti-panel"></i>
                    <span>Form Engine</span>
                </router-link>
            </li> -->
             <!-- v-if="$store.state.userData.role_id == 1 || $store.state.userData.role_id == 4" -->
            <li :class="{ 'show': $store.state.permission.includes('service.index') }">
                <router-link :to="{ name: 'instanceServices' }"
                    :class="setActive(['instanceServices', 'instanceServicesCreate', 'instanceServicesEdit'])">
                    <i class="ti-server"></i>
                    <span>Kategori Retribusi</span>
                </router-link>
            </li>

            <li 
                v-if="$store.state.userData.company.is_billing == 1 || $store.state.userData.company.is_transaction == 1"
                :class="{ 'show': $store.state.permission.includes('transaction.index') || $store.state.permission.includes('billing.index') }">
                <a href="javascript: void(0);"
                    :class="setActive(['instanceTransaction', 'instanceTransactionCreate', 'instanceTransactionEdit', 'instanceTransactionFixed', 'instanceTransactionFixedCreate', 'instanceTransactionFixedEdit'])">
                    <i class="ti-credit-card"></i>
                    <span>Transaksi</span>
                    <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
                </a>

                <ul class="nav-second-level" aria-expanded="false">
                    <li class="nav-item" :class="{ 'show': $store.state.permission.includes('transaction.index') }">
                        <router-link :to="{ name: 'instanceTransaction' }"
                            :class="setActive(['instanceTransaction', 'instanceTransactionCreate', 'instanceTransactionEdit'])">
                            <!-- <i class="ti-credit-card"></i> -->
                            <span>Daftar Tagihan</span>
                        </router-link>
                    </li>
                    <li class="nav-item" :class="{ 'show': $store.state.permission.includes('billing.index') }" v-if="$store.state.userData.company.is_billing == 1">
                        <router-link :to="{ name: 'instanceTransactionFixed' }"
                            :class="setActive(['instanceTransactionFixed', 'instanceTransactionFixedCreate', 'instanceTransactionFixedEdit'])">
                            <!-- <i class="ti-credit-card"></i> -->
                            <span>Transaksi Tetap</span>
                        </router-link>
                    </li>
                </ul>
            </li>

            <li :class="{ 'show': $store.state.permission.includes('customer.index') && $store.state.permission.includes('customer.store') }">
                <router-link :to="{ name: 'instanceCustomer' }"
                    :class="setActive(['instanceCustomer', 'instanceCustomerCreate', 'instanceCustomerEdit'])">
                    <i class="ti-signal"></i>
                    <span>Wajib Retribusi</span>
                </router-link>
            </li>

            <li :class="{ 'show': $store.state.permission.includes('master-data.index') }">
                <router-link :to="{ name: 'instanceMasterData' }"
                    :class="setActive(['instanceMasterData', 'instanceMasterDataCreate', 'instanceMasterDataEdit'])">
                    <i class="ti-align-justify"></i>
                    <span>Master Data</span>
                </router-link>
            </li>

            <li :class="{ 'show': $store.state.permission.includes('company-user.index') }">
                <router-link :to="{ name: 'instanceUser' }"
                    :class="setActive(['instanceUser', 'instanceUserCreate', 'instanceUserEdit'])">
                    <i class="ti-user"></i>
                    <span>User</span>
                </router-link>
            </li>

            <!-- <li class="show" v-if="companyType == 'OTHER'">
                <a href="javascript: void(0);"
                    :class="setActive(['instanceReportTransaction', 'instanceReportSummary'])">
                    <i class="ti-harddrives"></i>
                    <span>Laporan</span>
                    <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
                </a>

                <ul class="nav-second-level" aria-expanded="false">
                    <li class="nav-item show">
                        <router-link :to="{ name: 'instanceReportDetermination' }"
                            :class="setActive(['instanceReportDetermination'])">
                            <span>Laporan Penetapan</span>
                        </router-link>
                    </li>
                    <li class="nav-item show">
                        <router-link :to="{ name: 'instanceReportTransaction' }"
                            :class="setActive(['instanceReportTransaction'])">
                            <span>Laporan Transaksi</span>
                        </router-link>
                    </li>
                </ul>
            </li> -->
            <!-- companyType == 'HEALTH_CARE' -->
            <li :class="{ 'show': $store.state.permission.includes('report.sts') || $store.state.permission.includes('report.tbp') || $store.state.permission.includes('report.registration') || $store.state.permission.includes('report.cancel') || $store.state.permission.includes('report.determination') || $store.state.permission.includes('report.transaction') }">
                <a href="javascript: void(0);"
                    :class="setActive(['instanceSTS'])">
                    <i class="ti-harddrives"></i>
                    <span>Laporan</span>
                    <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
                </a>
                <ul class="nav-second-level" aria-expanded="false">
                    <li class="nav-item show" v-if="$store.state.permission.includes('report.sts') && companyType == 'HEALTH_CARE'">
                        <router-link :to="{ name: 'instanceReportSts' }"
                            :class="setActive(['instanceReportSts'])">
                            <span>Laporan STS</span>
                        </router-link>
                    </li>
                    <li class="nav-item show" v-if="$store.state.permission.includes('report.tbp') && companyType == 'HEALTH_CARE'">
                        <router-link :to="{ name: 'instanceReportTbp' }"
                            :class="setActive(['instanceReportTbp'])">
                            <span>Laporan TBP</span>
                        </router-link>
                    </li>
                    <li class="nav-item show" v-if="$store.state.permission.includes('report.registration') && companyType == 'HEALTH_CARE'">
                        <router-link :to="{ name: 'instanceReportRegistration' }"
                            :class="setActive(['instanceReportRegistration'])">
                            <span>Laporan Registrasi</span>
                        </router-link>
                    </li>
                    <li class="nav-item show" v-if="$store.state.permission.includes('report.cancel') && companyType == 'HEALTH_CARE'">
                        <router-link :to="{ name: 'instanceReportCancellation' }"
                            :class="setActive(['instanceReportCancellation'])">
                            <span>Laporan Pembatalan</span>
                        </router-link>
                    </li>
                    <li class="nav-item show" v-if="$store.state.permission.includes('report.determination')">
                        <router-link :to="{ name: 'instanceReportDetermination' }"
                            :class="setActive(['instanceReportDetermination'])">
                            <span>Laporan Penetapan</span>
                        </router-link>
                    </li>
                    <li class="nav-item show" v-if="$store.state.permission.includes('report.transaction')">
                        <router-link :to="{ name: 'instanceReportTransaction' }"
                            :class="setActive(['instanceReportTransaction'])">
                            <span>Laporan Transaksi</span>
                        </router-link>
                    </li>
                </ul>
            </li>

 
            <li :class="{ 'show': $store.state.permission.includes('qris-history.index') }">
                <router-link :to="{ name: 'instanceQrisHistory' }"
                    :class="setActive(['instanceQrisHistory'])">
                    <i class="ti-money"></i>
                    <span>Riwayat QRIS</span>
                </router-link>
            </li>

            <li :class="{ 'show': $store.state.userData.company.is_has_unit && $store.state.permission.includes('company-unit.index') }">
                <router-link :to="{ name: 'instanceUnit' }"
                    :class="setActive(['instanceUnit'])">
                    <i class="ti-layout"></i>
                    <span>Unit</span>
                </router-link>
            </li>

            <li :class="{ 'show': $store.state.permission.includes('company.setting') }">
                <router-link :to="{ name: 'instanceSettings' }"
                    :class="setActive(['instanceSettings'])">
                    <i class="ti-settings"></i>
                    <span>Pengaturan</span>
                </router-link>
            </li>
        </ul>

        <ul class="metismenu left-sidenav-menu menu-sidebar-layout" v-else-if="$cookies.get('type_user_login') == 'admin'">
            <li class="show">
                <router-link :to="{ name: 'adminInstance' }" 
                    :class="setActive([
                        'adminInstance', 'adminInstanceCreate', 'adminInstanceEdit',
                        'adminFormEngine', 'adminFormEngineCreate', 'adminFormEngineEdit',
                        'adminServices', 'adminServicesCreate', 'adminServicesEdit'
                    ])">
                    <i class="ti-harddrives"></i>
                    <span>Instansi</span>
                </router-link>
            </li>
            <li class="show">
            <router-link :to="{ name: 'adminOrganization' }"
                    :class="setActive(['adminOrganization', 'adminOrganizationCreate', 'adminOrganizationEdit'])">
                    <i class="ti-tablet"></i>
                    <span>Organization</span>
                </router-link>
            </li>
            <!-- <li class="show">
                <router-link :to="{ name: 'adminServices' }"
                    :class="setActive(['adminServices', 'adminServicesCreate', 'adminServicesEdit'])">
                    <i class="ti-server"></i>
                    <span>Kategori Retribusi</span>
                </router-link>
            </li> -->
            <li class="show">
                <router-link :to="{ name: 'adminGroup' }" 
                    :class="setActive(['adminGroup'])">
                    <i class="ti-briefcase"></i>
                    <span>Group</span>
                </router-link>
            </li>
            <li class="show">
                <router-link :to="{ name: 'adminUser' }" 
                    :class="setActive(['adminUser'])">
                    <i class="ti-user"></i>
                    <span>User Admin</span>
                </router-link>
            </li>
            <li class="show">
                <router-link :to="{ name: 'adminLog' }" 
                    :class="setActive(['adminLog'])">
                    <i class="ti-book"></i>
                    <span>Log</span>
                </router-link>
            </li>
            <li class="show">
                <router-link :to="{ name: 'adminSetting' }" 
                    :class="setActive(['adminSetting'])">
                    <i class="ti-settings"></i>
                    <span>Setting</span>
                </router-link>
            </li>
        </ul>

        <ul class="metismenu left-sidenav-menu menu-sidebar-layout" v-else>
            <li class="show">
                <router-link :to="{ name: 'groupDashboard' }" 
                    :class="setActive(['groupDashboard'])">
                    <i class="ti-bar-chart"></i>
                    <span>Beranda</span>
                </router-link>
            </li>

            <li class="show">
                <a href="javascript: void(0);"
                    :class="setActive(['groupTransaction', 'groupSummary'])">
                    <i class="ti-harddrives"></i>
                    <span>Laporan</span>
                    <span class="menu-arrow"><i class="mdi mdi-chevron-right"></i></span>
                </a>

                <ul class="nav-second-level" aria-expanded="false">
                    <li class="nav-item show">
                        <router-link :to="{ name: 'groupDetermination' }"
                            :class="setActive(['groupDetermination'])">
                            <span>Laporan Penetapan</span>
                        </router-link>
                    </li>
                    <li class="nav-item show">
                        <router-link :to="{ name: 'groupTransaction' }"
                            :class="setActive(['groupTransaction'])">
                            <span>Laporan Transaksi</span>
                        </router-link>
                    </li>
                    <li class="nav-item show">
                        <router-link :to="{ name: 'groupSummary' }"
                            :class="setActive(['groupSummary'])">
                            <span>Laporan Summary</span>
                        </router-link>
                    </li>
                </ul>
            </li>
            <!-- <li class="show">
                <router-link :to="{ name: 'groupTransaction' }" 
                    :class="setActive(['groupTransaction'])">
                    <i class="ti-harddrives"></i>
                    <span>Laporan Transaksi</span>
                </router-link>
            </li>
            <li class="show">
                <router-link :to="{ name: 'groupTransaction' }" 
                    :class="setActive(['groupTransaction'])">
                    <i class="ti-harddrives"></i>
                    <span>Rangkuman</span>
                </router-link>
            </li> -->
        </ul>

        <img src="@/assets/custom-images/powered-logo.png" alt="" class="powered-logo">
    </div>
</template>

<script>
export default {
    methods: {
        setActive(menu){
            if(menu.includes(this.$route.name)){
                return 'active'
            }
            return ''
        }
    }
}
</script>